import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';

import TemplateEditor from '@pages/TemplateEditor/TemplateEditor';
import Templates from '@pages/Templates/Templates';
import NewTemplate from '@pages/NewTemplate/NewTemplate';
import Login from '@pages/Login/LoginPage';
import LandingPage from '@pages/LandingPage/LandingPage';
import CustomEmail from '@pages/TemplateEditor/CustomEmail';
import EmailSent from '@pages/EmailSent/EmailSent';

import PrivateRoute from '@common/components/Auth/PrivateRoute';
import PublicRoute from '@common/components/Auth/PublicRoute';
import GuestRoute from '@common/components/Auth/GuestRoute';
import '@services/axiosConfig';

import { PAGE_ROUTES } from '@common/constants';

import styles from './AppRouter.module.scss';
import { useAuthStore } from '@store/authStore';
import EditTemplate from '@pages/EditTemplate/EditTemplate';

const RedirectToDefault = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(PAGE_ROUTES.LOGIN);
  });

  return <div />;
};

const AppRouter = () => {
  const { colorMode } = useAuthStore();
  return (
    <BrowserRouter>
      <div
        className={colorMode === 'light' ? styles.segment : styles.darkSegment}
      >
        <Routes>
          <Route
            path={PAGE_ROUTES.LOGIN}
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.LANDING_PAGE}
            element={
              <PublicRoute>
                <LandingPage />
              </PublicRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.TEMPLATE_EDITOR}
            element={
              <PrivateRoute>
                <EditTemplate />
              </PrivateRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.CUSTOM_EMAIL}
            element={
              <GuestRoute>
                <CustomEmail />
              </GuestRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.EMAIL_SENT}
            element={
              <GuestRoute>
                <EmailSent />
              </GuestRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.TEMPLATES}
            element={
              <PrivateRoute>
                <Templates />
              </PrivateRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.NEW_TEMPLATE}
            element={
              <PrivateRoute>
                <NewTemplate />
              </PrivateRoute>
            }
          />
          <Route
            path={PAGE_ROUTES.OTHER}
            element={
              <PrivateRoute>
                <RedirectToDefault />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default AppRouter;
